<template>
  <v-dialog v-model="modalActivo" persistent max-width="480">
    <v-container grid-list-sm text-center>
      <v-card class="mx-auto" :color="$store.state.sysBackgroundColor">
        <v-card-title>
          <v-layout row wrap>
            <v-flex>
              <h3 class="title">Agregar Artículo</h3>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex>
              <SelectArticulo
                :model="itemActivo.Id_Articulo"
                @seleccionarItem="seleccionarArticulo"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <v-text-field
                ref="controlFocoCantidad"
                label="Cantidad*"
                v-model="itemActivo.Cantidad"
                :readonly="seVendePorImporte"
                @keyup.enter="agregarArticulo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <Importe2
                label="Precio*"
                v-model="itemActivo.Precio"
                @seleccionarItem="agregarArticulo"
              />
            </v-flex>
            <v-flex xs6 md4>
              <Importe2
                v-if="seVendePorImporte"
                refocus="controlFocoImporte"
                label="Importe*"
                v-model="itemActivo.Importe"
                @seleccionarItem="agregarArticulo"
              />
              <Importe2
                v-else
                refocus="controlFocoImporte"
                label="Importe*"
                v-model="itemActivo.Importe"
                :readonly="true"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small rounded @click="ejecutarAccion('Cerrar')">
            Cancelar
            <v-icon right>clear</v-icon>
          </v-btn>
          <v-btn small rounded color="primary" @click="agregarArticulo">
            Aceptar
            <v-icon right>check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import SelectArticulo from "@/components/Stock/SelectArticulo";
import Importe2 from "@/components/Importe2";
export default {
  name: "ModalArticulo",
  props: {
    activo: Boolean,
    id_Articulo: Number,
    nombreModulo: String,
    esVentaContado: Boolean
  },
  components: {
    SelectArticulo,
    Importe2
  },
  data() {
    return {
      modalActivo: false,
      itemVacio: {
        Id_Articulo: 0,
        NombreArticulo: "",
        Id_TipoVentaArticulo: "",
        Id_TipoIvaArticulo: "",
        ImpuestoInternoArticulo: 0,
        TasaAArticulo: 0,
        Cantidad: 1.0,
        Precio: 0,
        PrecioLista: 0,
        Importe: 0
      },
      itemActivo: {}
    };
  },
  computed: {
    seVendePorImporte() {
      return (
        this.itemActivo.Id_TipoVentaArticulo ==
        this.$id_TipoVentaArticulo_PorImporte
      );
    }
  },
  watch: {
    activo() {
      this.modalActivo = this.activo;
      if (this.modalActivo) this.inicializar();
    }
  },
  methods: {
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      if (this.id_Articulo) this.buscarArticulo(this.id_Articulo);
      else {
        eventBus.$emit("inicializarSelectArticulo");
        setTimeout(() => {
          eventBus.$emit("setearFocoSelectArticulo");
        }, 100);
      }
    },
    ejecutarAccion(accion) {
      this.$emit("ejecutarAccion", accion, this.itemActivo);
    },
    buscarArticulo(id) {
      HttpHelper.get("Articulo", {
        id: id
      })
        .then(response => {
          if (response.data) this.seleccionarArticulo(response.data);
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    seleccionarArticulo(item) {
      if (item.Id_Articulo != 0) {
        this.itemActivo.Id_Articulo = item.Id_Articulo;
        this.itemActivo.NombreArticulo = item.NombreCodigoBarras;
        this.itemActivo.Id_TipoVentaArticulo = item.Id_TipoVentaArticulo;
        this.itemActivo.Id_TipoIvaArticulo = item.Id_TipoIvaArticulo;
        this.itemActivo.ImpuestoInternoArticulo = item.ImpuestoInterno;
        this.itemActivo.TasaAArticulo = item.TasaA;
        if (this.nombreModulo == this.$nombreModulo_Compra)
          this.itemActivo.Precio = item.Costo;
        else {
          this.itemActivo.Precio = this.esVentaContado
            ? item.Contado
            : item.Cuenta;
        }
        this.itemActivo.PrecioLista = this.itemActivo.Precio;
        this.validarTipoVentaArticulo();
      } else this.ejecutarAccion("Cerrar");
    },
    validarTipoVentaArticulo() {
      if (this.seVendePorImporte)
        this.itemActivo.Cantidad = this.itemActivo.Importe = 0;
      else {
        this.itemActivo.Cantidad = 1;
        this.itemActivo.Importe = this.itemActivo.Precio;
      }
      setTimeout(() => {
        if (this.seVendePorImporte)
          eventBus.$emit("setearFocoImporte", "controlFocoImporte");
        else this.$refs.controlFocoCantidad.focus();
      }, 100);
    },
    agregarArticulo() {
      if (this.seVendePorImporte) {
        if (this.itemActivo.Precio == this.itemActivo.PrecioLista)
          this.itemActivo.Cantidad = Number(
            this.itemActivo.Importe / this.itemActivo.Precio
          ).toFixed(4);
        else {
          this.itemActivo.Cantidad = Number(
            this.itemActivo.Importe / this.itemActivo.PrecioLista
          ).toFixed(4);
          this.itemActivo.Importe =
            this.itemActivo.Cantidad * this.itemActivo.Precio;
        }
      } else
        this.itemActivo.Importe =
          this.itemActivo.Cantidad * this.itemActivo.Precio;
      this.ejecutarAccion("Aceptar");
    }
  }
};
</script>
